module.exports = __webpack_public_path__ + "static/img/Daniel Wiyogo-full.886e19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Daniel Wiyogo-full.png
// module id = Hafy
// module chunks = 1